import React from 'react'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgyCheckbox from 'app/components/util/lgy-checkbox/LgyCheckbox'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { maxLength, numeric } from 'app/utils/validations'
import FetchFfpsUserDetails from '../components/FetchFfpsUserDetails'

const maxLength15 = maxLength(15)
const maxLength50 = maxLength(50)


const ExternalConnectionsForm = ({ pristine, submitting, submitFailed, submitSucceeded, reset, handleSubmit, error, user, ffpsUserDetailFetched, ffpsUsername, ffpsAffiliated, ffpsCheckboxForm}) =>
  <form onSubmit={handleSubmit}> 
    {submitSucceeded && <LgyAlertDialog type='success' heading='Status Updated' text='Account connection information was updated successfully.' />}
    <LgySubsection header='Access VA'>
      <Field
        name='vaEauthSecId'
        type='text'
        component={LgyInputField}
        label='AccessVA SecID'
        tooltip="To unlink an AccessVA account from this LGY account, delete the SecID and submit the form. To link an AccessVA account to this account, set this value to be equal to their SecID. See the wiki for more details on how to find a user's SecID."
        validate={[maxLength15, numeric]}
      />
    </LgySubsection>
    <LgySubsection header='api.va.gov'>
      <Field
        name='apiVaGovUserId'
        type='text'
        component={LgyInputField}
        label='api.va.gov User ID'
        tooltip="This is the user's ID in the api.va.gov system. This ID is required if this user wants to make API requests through api.va.gov to our system. A way to think of this is &quot;SecID is to accessVA as develeperVaGovUserID is to api.va.gov&quot;."
        validate={[maxLength50]}
      />
      <Field
        name='apiVaGovApiPin'
        type='text'
        component={LgyInputField}
        placeholder={user.apiVaGovApiPinExists ? 'This user has an API PIN. Override this field to change.' : 'This user does not have an API PIN.'}
        label='api.va.gov API PIN'
        tooltip="This is the user's API PIN for the api.va.gov system. This is used to prove ownership to an LGY account, and once an account is linked it will be cleared. The value is not displayed because it is encrypted."
        validate={[maxLength50]}
      />
    </LgySubsection>
    <LgySubsection header='Connect Internal'>
      <Field component={LgyCheckbox} label='Roll Connect Internal API Key' name='rollApiKey' tooltip="Rolls the API Key to a new value. The old value will continue to work provided it hasn't expired yet. If you want to invalidate the old key, then roll the key twice." />
      {user.apiKey
        ? <p>Connect Internal API Key rolled to {user.apiKey}.</p>
        : user.apiKeyExists
          ? <p>This user has a Connect Internal API Key.</p>
          : <p>This user does not have a Connect Internal API Key.</p>}
      </LgySubsection>
     {!user.isAffiliate && <LgySubsection header="FFPS Internal User Registration">
      <FetchFfpsUserDetails vaEauthSecId={user.vaEauthSecId} initialValues={{ffpsUsername: ffpsUsername, ffpsCheckbox: (ffpsAffiliated || ffpsUserDetailFetched)}} />
    </LgySubsection> }
    <LgyFormSubmit pristine={pristine && (!ffpsUserDetailFetched || (ffpsAffiliated && ffpsCheckboxForm))} submitting={submitting} submitFailed={submitFailed} submitSucceeded={submitSucceeded} error={error} reset={reset} />
  </form>

const selector = formValueSelector('fetchFfpsUserDetails')
const mapStateToProps = (state) => ({
   ffpsUserDetailFetched: state.ffpsUserDetail.fetched,
   ffpsUsername: state.ffpsUserDetail.ffpsUsername,
   ffpsAffiliated: state.ffpsUserDetail.ffpsAffiliated,
   ffpsCheckboxForm: selector(state, 'ffpsCheckbox')
})

export default connect(mapStateToProps)(reduxForm({
  enableReinitialize: true
})(ExternalConnectionsForm))